export default __webpack_public_path__ + "static/media/logo_refueling.d85a2dff.svg";